import { Injectable } from '@angular/core';
import { HttpClientJsonpModule, HttpClient, HttpErrorResponse, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ResponseContentType } from '@angular/http';
import { ok } from 'assert';
import {auth, obtenerCertificado, cambio, newContraseña} from '../models/ejemplo.model';


@Injectable()
export class ServicioService {

  private host: string = 'https://resistenciasbe.melon.cl';
  //private host: string = 'http://quimera.cl.lafarge.la/resistenciamelon';
  private controladorVMI: string = 'api/VstaIntegraAguaRpms/';
  private headerPost: any;
  private headerGet: any;
  constructor(private httpClient: HttpClient) {
    this.headerPost = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', "method": "post" });
    this.headerGet = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', "method": "get" });
  }

  autenticarUsuario(credenciales: auth): Observable<any>{
    return this.httpClient.post(this.host+'/api/Login/auth/', credenciales, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', "method": "post"
      })
    })
  }

  cambiarContraseña(cambio: cambio): Observable<any>{
    return this.httpClient.post(this.host+'/api/Login/cambio/', cambio, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', "method": "post"
      }).set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
    })
  }

  cambiarCorreo(email: newContraseña): Observable<any>{
    return this.httpClient.post(this.host+'/api/Login/cambioEmail/', email, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', "method": "post"
      }).set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
    })
  }

  nuevaContraseña(cambio: newContraseña): Observable<any>{
    return this.httpClient.post(this.host+'/api/Login/newPass/', cambio, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', "method": "post"
      })
    })
  }

  obtenerDatosCliente(cliente: string): Observable<any>{
    return this.httpClient.get(this.host+'/api/ObrasVigentes/ObtenerCliente?cliente='+cliente,  {
      headers: new HttpHeaders().set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
    });}

  obtenerObrasVigentes(cliente: string): Observable<any>{
    return this.httpClient.get(this.host+'/api/ObrasVigentes/ObtenerObrasVigentes?cliente='+cliente,  {
      headers: new HttpHeaders().set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
    });}


  obtenerObrasNoVigentes(cliente: string): Observable<any>{
    return this.httpClient.get(this.host+'/api/ObrasVigentes/ObtenerObrasNoVigentes?cliente='+cliente,  {
      headers: new HttpHeaders().set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
    });}
  obtenerResultados(codigo: any){
    return this.httpClient.get(this.host+'/api/ObrasVigentes/ObtenerResultado?obra='+codigo,  {
      headers: new HttpHeaders().set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
    });}

  obtenerInformacionObra(CodObra: any){
    return this.httpClient.get(this.host+'/api/ObrasVigentes/ObtenerInformacionObra?obra='+CodObra,  {
      headers: new HttpHeaders().set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
    });}
  obtenercertificado(cliente: any) : Observable<any>{
    return this.httpClient.post(this.host+'/api/Certificado/Obtenercertificado/', cliente, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', "method": "post"
      }).set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
    })
  }

  enviarCorreos(correo){
      return this.httpClient.post(this.host+'/api/Certificado/enviarCorreo/', correo, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', "method": "post"
        }).set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
      })
    }



}



// WEBPACK FOOTER //
// ./src/app/services/servicio.services.ts